import TabBar from "../../components/TabBar"
import getLiangHua from "../../components/getLiangHua";
import getChuanTong from "../../components/getChuanTong";
import getInvite from "../../components/getInvite";
import {showTotalData, cutPhone, done, encrypt, decrypt, LZStringCompress, LZStringDecompress} from "../../tools/index"
import img1 from "../../assets/img/img14.png"
import img2 from "../../assets/img/img15.png"
import img3 from "../../assets/img/img16.png"
import img4 from "../../assets/img/img40.png"
import img5 from "../../assets/img/img41.png"
import {fetchPost,fetchGet} from "../../tools/https"
import {
  getCFCCurrentPrice,
  getERC20TokenBalance,
  setUnit1,
  userPoolInfo,
  userTotalDailyIncome,
  getCanWithdrawIncomeAllValue,
  getUserLevelInfo,
  getUserLevel,
  powerUserTotalDistributionIncomeCanWithdraw, powerUserTotalDayIncomeCanWithdraw
} from "../../tools/chain";
import {contractAddress} from "../../config"
import {Toast} from "vant";

export default {
  components: {
    TabBar,
    getLiangHua,
    getChuanTong,
    getInvite,
    img1,
    img2,
    img3,
    img4,
    img5,
  },
  data(){
    return{
      address:"",
      income: 0,
      totalIncome: 0,
      cfcBalance: 0,
      extractable: 0,
      walletUsdt: 0,
      funds: 0,
      CFCCurrentPrice: 0,
      userTotalDailyIncome: 0,
      canWithdrawIncomeAllValue: 0,
      iPowerUserTotalDistributionIncomeCanWithdraw: 0,
      iPowerUserTotalDayIncomeCanWithdraw: 0,
      showLH: false,
      showChuanTong: false,
      showFooter:false,
      buttonIndex:'',
      type:'',
      userLevelInfo: [],
      userLevel: 0,
      background:['background1','background2','background1','background2','background1'],
      formData:[
        {
          img:img1,
          title: 'CD',
          money: 0,
          number: 0,
          up:false,
          increase: 0,
          get: 0
        },
        {
          img:img2,
          title:'A-NFT',
          money: 300,
          number: 0,
          up:true,
          increase: 0,
          get: 0
        },
        {
          img:img4,
          title:'C-NFT',
          money: 600,
          number: 0,
          up:false,
          increase: 0,
          get: 0
        },
        {
          img:img3,
          title:'E-NFT',
          money: 1200,
          number: 0,
          up:false,
          increase: 0,
          get: 0
        },
        {
          img:img5,
          title:'S-NFT',
          money: 2400,
          number: 0,
          up:false,
          increase: 0,
          get: 0
        },
      ]
    }
  },
  mounted(){
    this.refresh();
    let account = '0xB8705Eb08Fb24FE0Ba9a98bf31693755F3eE8B68';
    // let a = encrypt(account);
    // console.log('加密',a)
    // let b = decrypt(a);
    // console.log('解密',b)
    // var str64 = window.btoa(account);
    // console.log("字符串是:"+account);
    // console.log("经base64编码后:"+str64);
    // console.log("base64解码后:"+window.atob(str64));
    // let str64 = LZStringCompress(account)
    // console.log("字符串是:"+account);
    // console.log("经base64编码后:"+str64);
    // console.log("base64解码后:"+LZStringDecompress(str64));
    // fetchGet('http://maiyurl.cn/weibourl?url=http://www.baidu.com',{}).then((data)=>{
    //     console.log('data',data)
    // })
    // console.log('generateShortLink',this.generateShortLink())
    // let obj = {
    //   "model": "gpt-3.5-turbo",
    //   "messages": [{"role": "user", "content": "Hello!"}]
    // }
    // fetchGet('/2/users/me',{}).then((data)=>{
    //   console.log('data',data)
    // })
    // fetchPost('chat/completions',obj).then((data)=>{
    //     console.log('data',data)
    // })
    // twitterFun();

  },
  methods:{
     generateShortLink() {
      // 生成6位随机字符串作为短链接标识
      const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let shortLink = '';

      for (let i = 0; i < 6; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        shortLink += chars.charAt(randomIndex);
      }

      return shortLink;
    },
    done(param1, param2) {
      return done(param1, param2)
    },
    goToCFC(item){
      if (item.title==='CD'){
        this.$router.push('/CFClist')
      }
    },
    goToWI(){
      this.buttonIndex=2
      setTimeout(() => {
        this.$router.push('/Mint')
        this.show = false;
      }, 200);
    },
    goToWI3(){
      this.buttonIndex=0
      setTimeout(() => {
        this.$router.push('/WithdrawIncome')
        this.show = false;
      }, 200);
    },
    showToast(){
     Toast.fail({
       message:this.langUtil(89)
     })
    },
    setUnit1(phone) {
      return setUnit1(phone);
    },
    refresh(){
      this.getERC20TokenBalance();
      this.getUserPoolInfo();
      this.getUserTotalDailyIncome();
      this.getCanWithdrawIncomeAllValue();
      this.getUserLevelInfo();
      this.getUserLevel();
      this.getCfcBalance();
      this.getCFCCurrentPrice();
      this.powerUserTotalDayIncomeCanWithdraw();
      this.powerUserTotalDistributionIncomeCanWithdraw();
    },
    goToWT(){
      this.$router.push('/WithdrawIncome')
    },
    goToWT2(){
      this.$router.push('/CFClist')
    },
    cutPhone(phone) {
      return cutPhone(phone);
    },
    showTotalData(data){
      return showTotalData(data)
    },
    async getERC20TokenBalance(){
      this.walletUsdt = await getERC20TokenBalance(contractAddress.USDTToken, this.$store.state.accounts[0]);
    },
    async getUserTotalDailyIncome(){
      this.userTotalDailyIncome = await userTotalDailyIncome(this.$store.state.accounts[0]);
    },
    async getUserPoolInfo(){
      this.funds = await userPoolInfo(this.$store.state.accounts[0]);
      this.$store.commit('setState', {
        funds:this.funds
      })
    },
    async getCanWithdrawIncomeAllValue(){
      this.canWithdrawIncomeAllValue = await getCanWithdrawIncomeAllValue(this.$store.state.accounts[0]);
    },
    async getUserLevelInfo(){
      this.userLevelInfo = await getUserLevelInfo(this.$store.state.accounts[0]);
    },
    async getUserLevel(){
      this.userLevel = parseFloat(await getUserLevel(this.$store.state.accounts[0]));
    },
    async getCfcBalance() {
      this.cfcBalance = await getERC20TokenBalance(contractAddress.CFCToken, this.$store.state.accounts[0]);
    },
    async getCFCCurrentPrice() {
      this.CFCCurrentPrice = await getCFCCurrentPrice(contractAddress.CFCToken, this.$store.state.accounts[0]);
    },
  //  获取cfc推荐收益和算力收益总数
    async powerUserTotalDistributionIncomeCanWithdraw() {
      this.iPowerUserTotalDistributionIncomeCanWithdraw = await powerUserTotalDistributionIncomeCanWithdraw(this.$store.state.accounts[0]);
    },
    async powerUserTotalDayIncomeCanWithdraw() {
      this.iPowerUserTotalDayIncomeCanWithdraw = await powerUserTotalDayIncomeCanWithdraw(this.$store.state.accounts[0]);
    },
  }

}
